import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import SuperSearchList from '../../../../../../../shared/SuperSearch/SuperSearchList';
import DatePicker from '../../../../../../../General/DatePicker'
import isNull from '../../../../../../../../utils/NullChecking'
import FormValidator from '../../../../../../../../utils/FormValidator';
import { enumUtil } from '../../../../../../../../utils/Enum';
import SuperSearchSingleClient from '../../../../../../../shared/SuperSearch/SingleSelection/SuperSearchSingleClient';
import { ServerRequestProtected, ServerRequestPublic } from '../../../../../../../../utils/ServerDataRequest';
import { useSelector } from 'react-redux';
import { Modal, ModalBody } from "react-bootstrap";
import useCaptureDataAndGeneratePDF from '../../../../../../../shared/CaptureDataAndGeneratePDF/useCaptureDataAndGeneratePDF';
import Loader from '../../../../../../../shared/Loader/Loader';
import SOAPPreview from '../Components/SOAPPreview'
import AddNewAppointment from '../../../../../../../Scheduler/AddNewAppointment';
import ReloadGridAction from '../../../../../../../../actions/ReloadGridAction';
import { useDispatch } from 'react-redux';
import ModalHeader from '../../../../../../../Setup/Shared/ModalHeader';
import PrintOutSelectDataModal from '../Components/PrintOutSelectDataModal';
import SignEncounter from '../Components/SignEncounter';
import { encounterStatus } from '../Components/Constants';
import { FindFirstChild, FindSecondChild } from '../../../../../../../../utils/FindMenuOption';
import useClaimLinkingEncounter from '../Components/useClaimLinkingEncounter';
import ContentReceiver from '../../../../../../../MenuLayout/ContentReceiverNewBrowserTab/ContentReceiver';
import handleSetDropdownData from '../../../../../../../../utils/HandleSetDropdownData';
import CustomUseRef from '../../../../../../../shared/DropDown/CustomUseRef';
import NoteDisplaySettings from '../Components/NoteDisplaySettings';
import CurrentMaxDateValidator from '../../../../../../../../utils/CurrentMaxDateValidator';
import { IconAlert, IconPause } from '../../../../../../../shared/IconsComponent/icons';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import ImportTemplate from './ImportTemplate';
import NotificationHandler from '../../../../../../../../utils/NotificationHandler';
import AIEncounter from './AIEncounter';
import ViewTranscript from './ViewTranscript';
import { saveAs } from "file-saver"

const EncounterDetails = forwardRef((props, ref) => {
    let { is, setIs, initialData, searchParam, setSearchParam, searchValue, setSearchValue, providerDD, locationDD, printoutSelectDataModal, setPrintoutSelectDataModal, setIsProcedureEdit, mainServiceLineModal, setSelectedItems, handleSaveAIEncounter, isGroupNote, hasInitializedAIProcessing, setEncounterData } = { ...props };
    const isLive = process.env.REACT_APP_ISLIVE
    let isMainProviderSignatureAllowed = initialData?.Data?.isSignatureAllowed === "true";
    console.log("isMainProviderSignatureAllowed", isMainProviderSignatureAllowed)
    let isSaveEditAllowed = FindFirstChild('Patient', 'Encounter')?.IsAdd;
    let isSignEditAllowed = FindFirstChild('Patient', 'Sign Encounters')?.IsAdd;
    let isSuperbillEditAllowed = FindFirstChild('Patient', 'Add SuperBill')?.IsAdd;
    let isClaimViewAllowed = FindSecondChild('Billing', 'Claims', 'Claims')?.ISView
    let isCreateClaimEditAllowed = FindFirstChild('Patient', 'Create Claim For SuperBill')?.IsAdd;

    let { scrollTo, setScrollTo } = props;
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);
    let isCustomNote = props?.isCustomNote || "false";
    const visitTypes = useSelector(state => state.GeneralDropDownsReducer.EncounterType);

    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    let valModal = {}
    let ValidationModal = {
        EncounterTypeVal: "",
        NoteTypeVal: "",
        EncounterDateVal: "",
        SeenByVal: "",
        FacilityVal: "",
    }
    let reloadGrid = useSelector(state => state.ReloadGridReducer)
    let dispatch = useDispatch();
    const API_URL_General = enumUtil.controller.General
    const API_URL_AI = enumUtil.controller.AINoteWorkflows
    let PatientIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true))?.data?.id;
    // const API_URL = enumUtil.controller.General;
    const componentRef = useRef(null);
    // const [isCreatedByAppointment, setIsCreatedByAppointment] = useState(!!initialData?.Data?.IsAppointmentCreated === "true");

    let { divClaimLinking, LoadDD: LoadClaimDD, dataExist } = useClaimLinkingEncounter(props?.patientID, props?.encounterID, props?.setReloadAfterSave);
    const [openTab, setOpenTab] = useState('')

    const [showImportSection, setShowImportSection] = useState(false);
    const [isDetailEdit, setIsDetailEdit] = useState(false);
    const [encounterDetailsValidationModal, setEncounterDetailsValidationModal] = useState(ValidationModal);

    const [appointmentData, setAppointmentData] = useState([])

    const [isOpenAppointment, setIsOpenAppointment] = useState(false);
    const [appointmentID, setAppointmentID] = useState();
    const [hasReloaded, setHasReloaded] = useState(false);
    const [subMenuActive, setSubMenuActive] = useState(false);
    const [isSign, setIsSign] = useState(false)
    // ai note taker
    const [audioPopup, setAudioPopup] = useState(false);
    const [isAIProcessing, setIsAIProcessing] = useState(false);
    const [reRecordAI, setReRecordAI] = useState(false)
    const [resumeAI, setResumeAI] = useState(false)
    let activeRecordingEncounterIdExists = useSelector(state => state.ResumeAISessionReducer)?.activeRecordingEncounterId ?? '';

    const handleOpenAI = () => {
        if (activeRecordingEncounterIdExists) {
            if (activeRecordingEncounterIdExists !== initialData?.Data?.EncounterID) {
                NotificationHandler('You already have an active AI recording in another encounter.', enumUtil.enumtoaster.error)
                return
            } else {
                dispatch({ type: "OPEN_AI_POPUP", payload: { openAIPopup: true } }); // to open ai popup
                return
            }
        }
        if (initialData?.Data?.AIProcessingStatus === 'In Process') {
            setIsAIProcessing(true)
            return
        }
        if (initialData?.Data?.IsAIConfig !== 'true') return;
        setAudioPopup(true)
    }
    const handleCloseAIProcessing = () => {
        setIsAIProcessing(false)
    }
    const handleResumeAI = () => {
        if (initialData?.Data?.IsAIConfig !== 'true') return;
        setResumeAI(true)
        setAudioPopup(true)
        setIsAIProcessing(false)
        setReRecordAI(false)
    }
    const handleReRecordAI = () => {
        if (initialData?.Data?.IsAIConfig !== 'true') return;
        // setEncounterData(prev => ({
        //     ...prev,
        //     Data: {
        //         ...prev.Data,
        //         ActionToPerform: '',
        //         ClinicalAINoteJobsID: '',
        //         // AIProcessingStatus: 'New'
        //     }
        // }));
        setIsAIProcessing(false)
        setAudioPopup(true)
        setReRecordAI(true)
        setResumeAI(false)
    }
    const handleCloseAudio = () => {
        setAudioPopup(false)
        setReRecordAI(false)
        setIsAIProcessing(false)
        setResumeAI(false)
    }

    const handleImport = () => {
        setShowImportSection(true)
    }

    const LoadDD = () => {
        ServerRequestProtected(API_URL_General + "/DropDown", 'post', {
            "TableName": enumUtil.enumAPITableName.Encounter,
            "ID": PatientIDR,
        })
            .then((response) => {
                setAppointmentData(handleSetDropdownData(response, { functions: ['setEmptyDefault'] }))
            }).catch((error) => {
                setAppointmentData([])
            })
    }

    const handleEditSuperbill = () => {
        let element = document?.getElementById(`SuperBill-${initialData?.Data?.EncounterID}`)
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            setIsProcedureEdit(true);
        }
    }

    useEffect(() => {
        if (!scrollTo || !initialData?.Data?.EncounterID) return;
        if (scrollTo === 'Sign') {
            if (!isSignEditAllowed) return;
            setIsSign(true);
        }
        if (scrollTo === 'Add Superbill') {
            if (!isSuperbillEditAllowed) return;
            handleEditSuperbill();
        }
        setScrollTo(null);
    }, [scrollTo, initialData?.Data?.EncounterID])

    useEffect(() => {
        LoadClaimDD(searchParam?.EncounterDate);
    }, [searchParam?.EncounterDate]);

    useEffect(() => {
        LoadDD()
    }, [])
    useEffect(() => {
        if (!initialData?.Data?.AIProcessingStatus) return;
        if (!hasInitializedAIProcessing) return;
        if (hasInitializedAIProcessing.current) return;
        hasInitializedAIProcessing.current = true;
        if (initialData?.Data?.AIProcessingStatus === 'In Process') {
            if (initialData?.Data?.IsGroupEncounter === 'true' && isGroupNote) {
                setIsAIProcessing(true)
            } else if (!isGroupNote && isNull(initialData?.Data?.IsGroupEncounter)) {
                setIsAIProcessing(true)
            }
        }
    }, [initialData?.Data?.AIProcessingStatus])

    ////Reload on AppointmentSave
    useEffect(() => {
        if (reloadGrid?.AppointmentListEncounter === true) {
            LoadDD()
            setHasReloaded(true);
            // dispatch(ReloadGridAction({ AppointmentListEncounter: false }));
        }
    }, [reloadGrid?.AppointmentListEncounter])
    useEffect(() => {
        if (!reloadGrid?.AppointmentListEncounter && hasReloaded) {
            setHasReloaded(false); // allow future triggers again
        }
    }, [reloadGrid?.AppointmentListEncounter]);


    useImperativeHandle(ref, () => ({
        EncounterDetailsValidation
    }));

    const handleSelectedData = async (selectedData, name, type) => {
        if (type === 'client' && !isNull(selectedData)) {
            setIs(true);
            if (name === 'EncounterType') {
                setSearchParam({ ...searchParam, EncounterType: selectedData.value + "" })
                setSearchValue(prev => ({ ...prev, EncounterType: selectedData.display + "" }))
            }
            if (name === 'NoteType') {
                /// To Trigger Note Type Change Side Effects //////////////
                const { display, value } = selectedData;
                const userConfirmed = await props?.handleNoteTypeChange?.(
                    initialData?.Data?.NoteType,
                    value,
                    getSaveData,
                    setSearchParam,
                    setSearchValue,
                    display
                );
                if (!userConfirmed) return;
                // setSearchParam(prev => ({ ...prev, NoteType: selectedData.value + "", RemoveEncounterData: "true"}));
                // setSearchValue(prev => ({  ...prev, NoteType: selectedData.display + ""}));
            }
            if (name === 'SeenBy') {
                setSearchParam({ ...searchParam, SeenBy: selectedData.value + "" })
                setSearchValue(prev => ({ ...prev, SeenBy: selectedData.display + "" }))
            }
            if (name === 'Facility') {
                setSearchParam({ ...searchParam, Facility: selectedData.value + "" })
                setSearchValue(prev => ({ ...prev, Facility: selectedData.display + "" }))
            }
            if (name === 'PatientAppointmentID') {
                setSearchParam(prev => ({
                    ...prev,
                    PatientAppointmentID: selectedData?.value + "",
                    EncounterDate: selectedData?.AppointmentDate,
                }))
                setSearchValue(prev => ({
                    ...prev,
                    PatientAppointmentID: selectedData.AppointmentDate + "",
                }))
            }
            if (name === 'EncounterStatus') {
                setSearchParam({ ...searchParam, EncounterStatus: selectedData.value + "" })
                setSearchValue(prev => ({ ...prev, EncounterStatus: selectedData.display + "" }))
            }
        } else {
            setSearchParam({ ...searchParam, [name]: "" })
            setSearchValue(prev => ({ ...prev, [name]: "" }))
        }
        return selectedData
    }
    const handleCalendarChange = (date) => {
        setSearchParam({ ...searchParam, EncounterDate: date + "", PatientAppointmentID: "", SaveDuplicateEncounter: "false" })
        setSearchValue(prev => ({ ...prev, PatientAppointmentID: "" }))
    }
    const EncounterDetailsValidation = async () => {

        let encounterTypeVal = [-1, '-1'].includes(searchParam.EncounterType) ? '' : searchParam.EncounterType;
        let noteTypeVal = [-1, '-1'].includes(searchParam.NoteType) ? '' : searchParam.NoteType;
        // let encounterDateVal = [-1, '-1'].includes(searchParam.EncounterDate) ? '' : searchParam.EncounterDate;
        let seenByVal = [-1, '-1'].includes(searchParam.SeenBy) ? '' : searchParam.SeenBy;
        let facilityVal = [-1, '-1'].includes(searchParam.Facility) ? '' : searchParam.Facility;


        let ValidationModal = {
            EncounterTypeVal: FormValidator(
                encounterTypeVal,
                enumUtil.enumValidationType.Required,
                'Encounter Type',
            ),
            NoteTypeVal: FormValidator(
                noteTypeVal,
                enumUtil.enumValidationType.Required,
                'Note Type',
            ),
            EncounterDateVal: isNull(searchParam.EncounterDate) ?
                FormValidator(
                    searchParam.EncounterDate,
                    enumUtil.enumValidationType.Required,
                    'Encounter Date',
                ) :
                CurrentMaxDateValidator(
                    searchParam.EncounterDate,
                    enumUtil.enumValidationType.CurrentDate,
                    'Encounter Date',
                ),
            SeenByVal: FormValidator(
                seenByVal,
                enumUtil.enumValidationType.Required,
                'Provider',
            ),
            FacilityVal: FormValidator(
                facilityVal,
                enumUtil.enumValidationType.Required,
                'Location',
            )
        }
        valModal = ValidationModal
        await setEncounterDetailsValidationModal(ValidationModal)
        if (Object.values(ValidationModal).some(val => !isNull(val))) {
            setIsDetailEdit(true);
        }
        return valModal;
    }

    const getSaveData = async (arg1, arg2, arg3, savedFrom) => {
        if (savedFrom === 'Save Sign') {
            if (!isSignEditAllowed) return;
        } else if (savedFrom === 'Save Edit Superbill') {
            if (!isSuperbillEditAllowed) return;
        } else {
            if (!isSaveEditAllowed) return;
        }
        // if(!isSaveEditAllowed) return;
        const valModal = await EncounterDetailsValidation(); // call child's validate
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            setIsDetailEdit(true);
            props?.setSaveTrigger({
                [searchParam.NoteType]: false,
            });
            return
        } else {
            setIsDetailEdit(false);
            props?.setSaveTrigger(
                { [searchParam.NoteType]: true },
            );
        }
    }
    const handleOpenPreview = () => {
        if (activeRecordingEncounterIdExists && activeRecordingEncounterIdExists === initialData?.Data?.EncounterID) {
            return
        }
        props?.setShowPreview(true);
    }
    const handleClosePreview = () => {
        if (!isSaveEditAllowed) return;
        props?.setShowPreview(false);
    }

    // let isAppointmentCreated = (initialData?.Data?.IsAppointmentCreated === "true" && !!(initialData?.Data?.PatientAppointmentID));
    let apptTime = appointmentData.find(appt => appt.value == searchParam.PatientAppointmentID)?.AppointmentStart || initialData?.Data?.AppointmentStart;

    const AddAppointment = () => {
        let ID = searchParam?.PatientAppointmentID;
        setAppointmentID(ID)
        setIsOpenAppointment(true);
    }
    const CloseAppointment = () => {
        setIsOpenAppointment(false);
        // props?.setReloadAfterSave(true);
    }
    const handleOnCloseSave = () => {
        setIsOpenAppointment(false);
        props?.setReloadAfterSave(true);
    }
    //////////Claim/////////////////
    const handleCreateClaim = () => {
        if (!isCreateClaimEditAllowed) return;
        let dataForClaim = {
            EncounterID: initialData?.Data?.EncounterID,
            PatientID: initialData?.Data?.PatientID,
            PatientName: initialData?.Data?.PatientName,
        }
        let dataObj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                name: "New Professional",
                id: -1,
                time: new Date(),
                visitType: "P",
                EncounterID: dataForClaim
            },
        };
        setOpenTab(dataObj)
    }
    const handleViewClaim = () => {
        if (!isClaimViewAllowed) return;
        let obj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                id: initialData.Data.ClaimID,
                name: initialData.Data.PatientName,
                time: new Date(),
                visitType: initialData.Data?.ClaimType,
                EncounterID: initialData?.Data?.EncounterID,
                PatientID: initialData?.Data?.PatientID,
            },
        };
        setOpenTab(obj)
    }
    ///////////////////////////////
    let PopupScreen = "";
    if (isOpenAppointment) {
        PopupScreen = <AddNewAppointment
            AppointmentID={appointmentID}
            showEvents={isOpenAppointment}
            handleOnClose={CloseAppointment}
            handleOnCloseSave={handleOnCloseSave}
            providerID={initialData.Data?.SeenBy}
            locationID={initialData.Data?.LocationID}
            PatientID={initialData.Data?.PatientID}
            choosenDate={initialData.Data?.AppointmentDate}
        />
    }
    const handleSign = () => {
        if (!isSignEditAllowed || !isMainProviderSignatureAllowed) return;
        setIsSign(true);
    }
    const handleCoSign = () => {
        if (!isSignEditAllowed) return;
        setIsSign(true);
    }
    let noValExistTextNA = <p className="fst-italic light-clrs text">N/A</p>;

    const handleSubActiveMenu = (e) => {
        setSubMenuActive(!subMenuActive)
        e.stopPropagation();
    }

    const closeDropdown = () => {
        setSubMenuActive(false)
    };

    // const handleAddEncounter = (data) => {
    //     handleSaveAIEncounter(data)
    // }

    const coSignList = initialData?.EncounterCoSign || [];
    const coSignItemData = initialData?.EncounterCoSign?.find(it => it?.isCoSigned === "false" && it?.isSignatureAllowed === "true");
    const coSignProps = {
        isOpenedFrom: "CoSign",
        canCoSign: coSignItemData && props?.initialData?.Data?.EncounterStatus === "To Be Co-Signed",
        coSignItemData,
        coSignList,
        setSaveEncounterCoSignData: props?.setSaveEncounterCoSignData,
        handleSign: handleCoSign,
        isToBeCoSignedStatus: props?.initialData?.Data?.EncounterStatus === "To Be Co-Signed"
    };

    const [viewTranscript, setViewTranscript] = useState(false)
    const handleViewTranscript = () => {
        setViewTranscript(true)
    }
    const CloseViewTranscript = () => {
        setViewTranscript(false)
    }
    let viewTranscriptPopup
    if (viewTranscript) {
        viewTranscriptPopup = <ViewTranscript viewTranscript={viewTranscript} CloseViewTranscript={CloseViewTranscript} encounterID={initialData?.Data?.EncounterID} />
    }

    const list = Object.values(props?.customTemplateData || {})[0];
    // const isEmpty = !list || list.length === 0;
    const viewImport = isCustomNote === "true" || (props?.customTemplateData?.length ?? 0) === 0; // if Note Type is Custom or else Custom Template Data has no item


    const [isLoading, setIsLoading] = useState(false);
    const [showAiIcon, setShowAiIcon] = useState(true)


    const showDisplaySetting = isCustomNote !== "true";
    const showImport = viewImport && !isGroupNote;
    const showTranscript =
        initialData?.Data?.IsAIGenerated === "true" &&
        !isNull(initialData?.Data?.ClinicalAINoteJobsID);

    const showSubMenuButton =
        showDisplaySetting ||
        showImport ||
        showTranscript;

    //download audio transcript
    // const [isLoading, setIsLoading] = useState(false);
    const API_URL_AINoteWorkflows = enumUtil.controller.AINoteWorkflows
    const handleDownloadAudioTranscript = () => {
        setIsLoading(true)
        ServerRequestPublic(API_URL_AINoteWorkflows + "/DownloadEncounterFiles?EncounterID=" + initialData?.Data?.EncounterID, 'GET', '', "Download", '')
            .then((response) => {
                let blob = new Blob([response]);
                saveAs(blob, "AudioTranscript" + ".zip");
                setIsLoading(false)
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            })
    }

    // Individual encounters must never see group templates in the dropdown.
    // Group encounters keep the full list, but the field is read-only there anyway.
    const filteredNoteTypes = useMemo(() => {
        const isEncounterGroupNote = [true, 'true'].includes(initialData?.Data?.IsGroupEncounter);
        if (isEncounterGroupNote) return noteTypes;
        return (noteTypes || []).filter(nt => nt?.IsGroupTemplate !== true);
    }, [noteTypes, initialData?.Data?.IsGroupEncounter]);
    // console.log("filteredNoteTypes", 
    //     filteredNoteTypes, 
    //     noteTypes.filter(nt => nt?.IsGroupTemplate === true)

    // )
    return (
        <>
            {PopupScreen}
            {isSettingsOpen ? <NoteDisplaySettings noteType={searchParam.NoteType} setIsSettingsOpen={setIsSettingsOpen} defaultSelectedItems={props?.defaultSelectedItems} setDefaultSelectedItems={props?.setDefaultSelectedItems} searchParam={searchParam} setSelectedItems={setSelectedItems} insertPosition={props?.insertPosition} /> : <></>}
            {openTab ? <ContentReceiver data={openTab} setOpenTab={setOpenTab} /> : null}
            {isSignEditAllowed ?
                <SignEncounter isSign={isSign} setIsSign={setIsSign} providerName={initialData?.Data?.ProviderName || ''} initialDataData={initialData?.Data || {}} setSearchParam={setSearchParam} getSaveData={getSaveData} coSignProps={coSignProps} /> : <></>}
            {props?.showPreview ?
                <SOAPPreview data={initialData} searchParam={searchParam} searchValue={searchValue} handleClosePreview={handleClosePreview} saveAddendumData={props?.saveAddendumData} setSaveAddendumData={props?.setSaveAddendumData} getSaveData={getSaveData} isGroupNote={isGroupNote}
                    // pritnoutPopup={pritnoutPopup} setPrintoutPopup={setPrintoutPopup}
                    printoutSelectDataModal={printoutSelectDataModal} setPrintoutSelectDataModal={setPrintoutSelectDataModal} setIsProcedureEdit={setIsProcedureEdit} dataExist={dataExist} divClaimLinking={divClaimLinking} mainServiceLineModal={mainServiceLineModal} handleCreateClaim={handleCreateClaim} handleViewClaim={handleViewClaim} coSignProps={coSignProps} />
                :
                <>
                    <div className='position-relative'>
                        {isDetailEdit === true && (
                            <div className="ar-top-content ">
                                {/* <p className="heading fs-13 pb-2" >Encounter Details</p> */}
                                <div className="row m-0 row-gap-10 align-items-end">
                                    {/* <div className={isAppointmentCreated ? 'col-md-3' : 'col-md-6 ps-0'}> */}
                                    <div className='col-md-3 ps-0'>
                                        <div className={`input form-group ar-multiple-br m-0 w-100 ${encounterDetailsValidationModal.EncounterTypeVal ? 'error' : ''}`}>
                                            <label>Encounter Type</label>
                                            <SuperSearchList
                                                type="client"
                                                id='EncounterType'
                                                name='EncounterType'
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                searchValue={searchValue.EncounterType}
                                                data={visitTypes}
                                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, EncounterType: e.target.value }) }}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                placeholder={false}
                                                inputError={encounterDetailsValidationModal?.EncounterTypeVal}
                                            />
                                            {encounterDetailsValidationModal?.EncounterTypeVal}
                                        </div>
                                    </div>
                                    <div className="col-md-3 ps-0">
                                        <div className={`input form-group ar-multiple-br m-0 w-100 ${encounterDetailsValidationModal.NoteTypeVal ? 'error' : ''}`}>
                                            <label>Note Type</label>
                                            <SuperSearchList
                                                type="client"
                                                id='NoteType'
                                                name='NoteType'
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                searchValue={searchValue.NoteType}
                                                isReadOnly={initialData?.Data?.IsGroupEncounter === 'true' || initialData?.Data?.IsAIGenerated === 'true' ? true : false}
                                                data={filteredNoteTypes}
                                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, NoteType: e.target.value }) }}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                placeholder={false}
                                                inputError={encounterDetailsValidationModal?.NoteTypeVal}
                                            />
                                            {encounterDetailsValidationModal.NoteTypeVal}
                                        </div>
                                    </div>
                                    {
                                        // isAppointmentCreated === true && 
                                        (
                                            <div className="col-md-3 ps-0">
                                                <div className={`input form-group ar-multiple-br m-0 w-100`}>
                                                    <label>Appointment</label>
                                                    {/* <SuperSearchList
                                                type="client"
                                                id='NoteType'
                                                name='NoteType'
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                searchValue={searchValue.NoteType}
                                                data={noteTypes}
                                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, NoteType: e.target.value }) }}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                placeholder={false}
                                                inputError={encounterDetailsValidationModal?.NoteTypeVal}
                                            /> */}
                                                    <SuperSearchSingleClient
                                                        type="client"
                                                        id='PatientAppointmentID'
                                                        name='PatientAppointmentID'
                                                        icon={'Simple'}
                                                        sup_btn='sup_btn'
                                                        sup_inp='superSearchVisitInp'
                                                        searchValue={searchValue?.PatientAppointmentID}
                                                        data={appointmentData}
                                                        onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, PatientAppointmentID: e.target.value }) }}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        placeholder={false}
                                                        SuperSearchView="DetailedView"
                                                        DetailedView="PatientEncounterAppt"
                                                        inputError={encounterDetailsValidationModal?.PatientAppointmentIDVal}
                                                    />
                                                    {/* {encounterDetailsValidationModal.NoteTypeVal} */}
                                                </div>
                                            </div>

                                        )}
                                    <div className="col-md-3 px-0">
                                        <div className={`input form-group m-0 w-100 ${encounterDetailsValidationModal.EncounterDateVal ? 'error' : ''}`}>
                                            <label>Encounter Date</label>
                                            {/* <DatePicker /> */}
                                            <div className="d-flex align-items-center gap-10">
                                                <div className="w-100">
                                                    <DatePicker
                                                        value={searchParam.EncounterDate}
                                                        handleCalendarChangefunc={date => handleCalendarChange(date)}
                                                        className='w-100'
                                                        maxDate={new Date()}
                                                    />
                                                </div>
                                                {encounterDetailsValidationModal.EncounterDateVal}
                                                <div className="d-flex align-items-center gap-2 flex-nowrap">
                                                    <i className="icon-close cursor-pointer fs-11" onClick={() => { setIsDetailEdit(false) }}></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3 ps-0">
                                        <div className={`input form-group ar-multiple-br m-0 w-100 ${encounterDetailsValidationModal.SeenByVal ? 'error' : ''}`}>
                                            <label>Provider</label>
                                            <SuperSearchList
                                                type="client"
                                                id='SeenBy'
                                                name='SeenBy'
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                searchValue={searchValue.SeenBy}
                                                data={providerDD}
                                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, SeenBy: e.target.value }) }}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                placeholder={false}
                                                inputError={encounterDetailsValidationModal?.SeenByVal}
                                            />
                                            {encounterDetailsValidationModal.SeenByVal}
                                        </div>
                                    </div>
                                    <div className="col-md-3 ps-0">
                                        <div className={`input form-group ar-multiple-br m-0 w-100 ${encounterDetailsValidationModal.FacilityVal ? 'error' : ''}`}>
                                            <label>Location</label>
                                            <SuperSearchList
                                                type="client"
                                                id='Facility'
                                                name='Facility'
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                searchValue={searchValue.Facility}
                                                data={locationDD}
                                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, Facility: e.target.value }) }}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                placeholder={false}
                                                inputError={encounterDetailsValidationModal?.FacilityVal}
                                            />
                                            {encounterDetailsValidationModal.FacilityVal}
                                        </div>
                                    </div>
                                    <div className="col-md-6 px-0">
                                        <div className="d-flex justify-content-between align-items-end">
                                            <div className="input">
                                                {/* <div className={`input form-group ar-multiple-br m-0 w-100 ${encounterDetailsValidationModal.NoteTypeVal ? 'error' : ''}`}> */}
                                                <label>Status</label>
                                                <SuperSearchList
                                                    type="client"
                                                    id='EncounterStatus'
                                                    name='EncounterStatus'
                                                    icon={'Simple'}
                                                    sup_btn='sup_btn'
                                                    sup_inp='superSearchVisitInp'
                                                    searchValue={searchValue.EncounterStatus}
                                                    data={encounterStatus}
                                                    onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, EncounterStatus: e.target.value }) }}
                                                    getSelectedData={handleSelectedData}
                                                    is={is}
                                                    placeholder={false}
                                                // inputError={encounterDetailsValidationModal?.EncounterStatusVal}
                                                />
                                                {/* {encounterDetailsValidationModal.NoteTypeVal} */}
                                                {/* </div> */}
                                                {/* {searchParam.EncounterStatus === 'Signed' ?
                                                <p className='Not-Signed heading font-m ar-status-clm w-fit-content h-auto py-3-5'>Signed</p> :
                                                searchParam.EncounterStatus === 'Unsigned' &&
                                                <p className='Not-Signed heading font-m ar-status-clm w-fit-content h-auto py-3-5'>Unsigned</p>} */}
                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <button className={`btn rounded btn-Signed ${(isSignEditAllowed && isMainProviderSignatureAllowed) ? '' : 'disabled'}`} onClick={handleSign}>Sign</button>
                                                <button className='btn rounded btn-light' onClick={handleOpenPreview}>Preview</button>
                                                <div className="d-flex align-items-center gap-2">
                                                    <span className="icon-Group-1000002858 fs-20" onClick={() => setPrintoutSelectDataModal(true)}><span className="path1"></span><span className="path2"></span></span>

                                                    {/* <div className="position-relative hk-opt-bar br-clr br-left-1 ps-2px">
                                                        <button className="btn-icon-transparent claim_submenu lh-10 border-0 p-0" onClick={handleSubActiveMenu}><i class="icon-dots-menu lh-20"></i>
                                                            {<CustomUseRef onClose={closeDropdown} IsActivePtPayments={subMenuActive}>
                                                                {subMenuActive === true ?
                                                                    <div className='claims-TabHeader__right__submenu right-7 top-100-5 active user-select-none'>
                                                                        {isCustomNote === "true" ? <></> :
                                                                            <div className="itemList py-2">
                                                                                <div className="itemList__item" onClick={() => setIsSettingsOpen(true)}>Display Setting</div>
                                                                            </div>
                                                                        }
                                                                        {viewImport &&
                                                                            <div className="itemList py-2" onClick={handleImport}>
                                                                                <div className="itemList__item" >Import</div>
                                                                            </div>}
                                                                        {initialData?.Data?.IsAIGenerated === 'true' ?
                                                                            <div className="itemList py-2" onClick={handleViewTranscript}>
                                                                                <div className="itemList__item">View Transcript</div>
                                                                            </div>
                                                                            : null}
                                                                    </div>
                                                                    : null
                                                                }
                                                            </CustomUseRef>}
                                                        </button>
                                                    </div> */}
                                                    {showSubMenuButton && (
                                                        <div className="position-relative hk-opt-bar br-clr br-left-1 ps-2px">
                                                            <button className="btn-icon-transparent claim_submenu lh-10 border-0 p-0" onClick={handleSubActiveMenu}>
                                                                <i className="icon-dots-menu lh-20"></i>
                                                                <CustomUseRef onClose={closeDropdown} IsActivePtPayments={subMenuActive}>
                                                                    {subMenuActive && (
                                                                        <div className="claims-TabHeader__right__submenu right-7 top-100-5 active user-select-none  w-202px">
                                                                            <div className="itemList py-2">
                                                                                {showDisplaySetting && (
                                                                                    <div className="itemList__item" onClick={() => setIsSettingsOpen(true)}>
                                                                                        Display Setting
                                                                                    </div>
                                                                                )}
                                                                                {showImport && (
                                                                                    <div className="itemList__item" onClick={handleImport}>
                                                                                        Import
                                                                                    </div>
                                                                                )}
                                                                                {showTranscript && (
                                                                                    <div className="itemList__item" onClick={handleViewTranscript} >
                                                                                        View Transcript
                                                                                    </div>
                                                                                )}
                                                                                {showTranscript && (
                                                                                    <div className="itemList__item" onClick={handleDownloadAudioTranscript}>Download Audio & Transcript</div>
                                                                                )}
                                                                            </div>

                                                                        </div>
                                                                    )}
                                                                </CustomUseRef>
                                                            </button>
                                                        </div>
                                                    )}
                                                    {/* <span className="icon-Group-1000002859 fs-20 br-clr br-left-1 ps-2" ><span className="path1"></span><span className="path2"></span></span>
                                                <div className="position-relative hk-opt-bar br-clr br-left-1 ps-2px">
                                                    <button className="btn-icon-transparent claim_submenu lh-10 border-0 p-0" onClick={handleSubActiveMenu}><i class="icon-dots-menu lh-20"></i>
                                                        {<CustomUseRef onClose={closeDropdown} IsActivePtPayments={subMenuActive}>
                                                            {subMenuActive === true ?
                                                                <div className='claims-TabHeader__right__submenu right-7 top-100-5 active'>
                                                                    <div className="itemList py-2">
                                                                        <div className="itemList__item" >Audit</div>
                                                                    </div>
                                                                </div>
                                                                : null
                                                            }
                                                        </CustomUseRef>}
                                                    </button>
                                                </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        )}
                        {isDetailEdit === false && (
                            <div className="row m-0 row-gap-10 align-items-end g-0 encounter-edit-mode p-2">
                                <div className="col-md-3">
                                    <div className="row m-0 align-items-end">
                                        <div className="col-md-5 px-0">
                                            <p className='heading'>Encounter Type</p>
                                        </div>
                                        <div className="col-md-7 pe-0 ps-2">
                                            <p className="text validation_message text-nowrap" title={searchValue?.EncounterType}>{searchValue?.EncounterType || noValExistTextNA}</p>
                                        </div>

                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="row m-0 align-items-end">
                                        <div className="col-md-3 text-nowrap px-0">
                                            <p className='heading'>Note Type</p>
                                        </div>
                                        <div className="col-md-8 pe-0 ps-10">
                                            <p className="text validation_message text-nowrap" title={searchValue.NoteType}>{searchValue.NoteType || noValExistTextNA}</p>
                                        </div>

                                    </div>
                                </div>
                                {
                                    // isAppointmentCreatedView && 
                                    (
                                        <div className="col-md-3">
                                            <div className="row m-0 align-items-end">
                                                <div className="col-md-4 px-0">
                                                    <p className='heading'>Appointment</p>
                                                </div>
                                                <div className="col-md-8 pe-0 ps-10">
                                                    {searchParam?.PatientAppointmentID ?
                                                        <p className="text validate-color cursor-pointer validation_message text-nowrap pe-1-5" title={`${apptTime} - ${initialData?.Data?.AppointmentStatus}`} onClick={() => AddAppointment()}>{apptTime} - {initialData?.Data?.AppointmentStatus}</p> : noValExistTextNA}
                                                </div>

                                            </div>
                                        </div>
                                    )}
                                {/* <div className={isAppointmentCreatedView ? 'col-md-3' : 'col-md-6'}> */}
                                <div className='col-md-3' >
                                    <div className="d-flex align-items-end justify-content-between">
                                        <div className="row m-0 align-items-end w-100">
                                            {/* <div className={isAppointmentCreated ? "col-md-5 text-nowrap px-0" : "col-md-3 px-0"}> */}
                                            <div className="col-md-5 text-nowrap px-0" >
                                                <p className='heading'>Encounter Date:</p>
                                            </div>
                                            {/* <div className={isAppointmentCreated ? "col-md-7 pe-0 ps-3" : "col-md-9 pe-0"}> */}
                                            <div className="col-md-7 pe-0 ps-10">
                                                {searchParam.EncounterDate ?
                                                    <p className="text">{searchParam.EncounterDate}</p> : noValExistTextNA
                                                }
                                            </div>

                                        </div>
                                        {/* <i className='icon-Icon-material-edit fs-11 ar-light-color' onClick={() => { setIsDetailEdit(true) }}></i> */}
                                        <i className={`icon-Icon-material-edit fs-11 ar-light-color ${isSaveEditAllowed ? '' : 'disable'}`} onClick={() => {
                                            if (!isSaveEditAllowed) return;
                                            setIsDetailEdit(true)
                                        }}></i>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="row m-0 align-items-end">
                                        <div className="col-md-5 px-0">
                                            <p className='heading'>Provider</p>
                                        </div>
                                        <div className="col-md-7 pe-0 ps-2">
                                            <p className="text  validation_message text-nowrap" title={searchValue.SeenBy}>{searchValue.SeenBy || noValExistTextNA}</p>
                                        </div>

                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="row m-0 align-items-end">
                                        <div className="col-md-3 px-0">
                                            <p className='heading'>Location</p>
                                        </div>
                                        <div className="col-md-8 pe-0 ps-10">
                                            <p className="text validation_message text-nowrap" title={searchValue.Facility}>{searchValue.Facility || noValExistTextNA}</p>
                                        </div>

                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="d-flex align-items-end justify-content-between">
                                        <div className="d-flex align-items-center gap-1 mw-100 flex-wrap">
                                            <div className="d-flex align-items-center gap-6">
                                                <p className='heading'>Status</p>
                                                <div className="">
                                                    {searchParam.EncounterStatus === 'Signed' ?
                                                        <p className='Paid heading font-m ar-status-clm w-fit-content h-auto py-0'>Signed</p> :
                                                        searchParam.EncounterStatus === 'In Progress' ?
                                                            <p className='Blue-Status heading font-m ar-status-clm w-fit-content h-auto py-0'>In Progress</p> :
                                                            searchParam.EncounterStatus === 'Ready for Review' ?
                                                                <p className='In-Review heading font-m ar-status-clm w-fit-content h-auto py-0'>Ready for Review</p> :
                                                                ['Unsigned', 'UnSigned'].includes(searchParam.EncounterStatus) &&
                                                                <p className='Not-Signed heading font-m ar-status-clm w-fit-content h-auto py-0'>Unsigned</p>}
                                                    {searchParam.EncounterStatus ? <></> : noValExistTextNA}
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center cursor-pointer ps-1 br-left-1 br-clr-light text-nowrap">
                                                {!isNull(initialData?.Data?.EncounterID) && !isGroupNote && (
                                                    !isNull(initialData?.Data?.ClaimID) ? (
                                                        <div className={`d-flex align-items-center ${isClaimViewAllowed ? "" : "disable"}`}>
                                                            <p className="heading fs-11 validate-color" onClick={handleViewClaim}>
                                                                View Claim
                                                            </p>
                                                            <i className="icon-enrollment fs-13 lh-9"></i>
                                                        </div>
                                                    ) : (
                                                        <div className={`d-flex align-items-center ${isCreateClaimEditAllowed ? "" : "disable"}`}>
                                                            {dataExist ? (
                                                                divClaimLinking
                                                            ) : (
                                                                mainServiceLineModal?.some(serviceLine => !isNull(serviceLine.SuperBillID)) && (
                                                                    <div
                                                                        className="d-flex align-items-center cursor-pointer"
                                                                        onClick={handleCreateClaim}
                                                                    >
                                                                        <p className="heading fs-11 validate-color">
                                                                            Create Claim
                                                                        </p>
                                                                        <i className="icon-enrollment fs-13 lh-9"></i>
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                            {/* <p className='heading fs-11 validate-color'>View Claim</p>
                                            <i className='icon-enrollment fs-13 lh-9'></i> */}
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            {initialData?.Data?.IsAIGenerated === 'true' && initialData?.Data?.IsGroupEncounter !== 'true' &&
                                                showAiIcon && initialData?.Data?.AIProcessingStatus !== 'Applied' ?
                                                <div className={`ai-enable-encounter flex-center ${initialData?.Data?.IsAIConfig === 'true' ? '' : 'disabled'}`}
                                                    onClick={() => handleOpenAI()}>
                                                    <i className='icon-Voice fs-12'></i>
                                                </div>
                                                : initialData?.Data?.IsAIGenerated === 'true' && initialData?.Data?.IsGroupEncounter === 'true' && isGroupNote &&
                                                    showAiIcon && initialData?.Data?.AIProcessingStatus !== 'Applied' ?
                                                    <div className={`ai-enable-encounter flex-center ${initialData?.Data?.IsAIConfig === 'true' ? '' : 'disabled'}`}
                                                        onClick={() => handleOpenAI()}>
                                                        <i className='icon-Voice fs-12'></i>
                                                    </div> : null
                                            }
                                            {!isGroupNote ?
                                                <button className={`btn rounded btn-Signed ${(isSignEditAllowed && isMainProviderSignatureAllowed) ? '' : 'disabled'}`} onClick={handleSign}>Sign</button>
                                                : null}
                                            <button className={`btn rounded btn-light ${activeRecordingEncounterIdExists === initialData?.Data?.EncounterID ? 'disabled' : ''}`} onClick={handleOpenPreview}>Preview</button>
                                            <div className="d-flex align-items-center gap-2">
                                                {/* {isLive === "true" ? null :
                                                    <div class="app_tooltip left">
                                                        <i className='icon-Join-meeting fs-14 lh-20 br-clr br-right-1 pe-2'></i>
                                                        <p className="tool_tip xsm_text text-light">Join Visit</p>
                                                    </div>
                                                }
                                               

                                                {/* {isCustomNote === "true" ? <></> :
                                                <span className="icon-Group-1000002859 fs-20 br-clr br-left-1 ps-2" onClick={() => setIsSettingsOpen(true)}>
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </span>} */}
                                                {/* {isGroupNote ? null : */}
                                                <span className="icon-Group-1000002858 fs-20" onClick={() => setPrintoutSelectDataModal(true)}>
                                                    <span className="path1"></span><span className="path2"></span>
                                                </span>
                                                {/* } */}

                                                {showSubMenuButton && (
                                                    <div className="position-relative hk-opt-bar br-clr br-left-1 ps-2px">
                                                        <button className="btn-icon-transparent claim_submenu lh-10 border-0 p-0" onClick={handleSubActiveMenu}><i class="icon-dots-menu lh-20"></i>
                                                            {<CustomUseRef onClose={closeDropdown} IsActivePtPayments={subMenuActive}>
                                                                {subMenuActive === true ?
                                                                    <div className='claims-TabHeader__right__submenu right-7 top-100-5 active user-select-none w-202px'>
                                                                        <div className="itemList py-2">
                                                                            {showDisplaySetting && (
                                                                                <div className="itemList__item" onClick={() => setIsSettingsOpen(true)}>Display Setting</div>
                                                                            )}
                                                                            {showImport && (
                                                                                <div className="itemList__item" onClick={handleImport} >Import</div>
                                                                            )}
                                                                            {showTranscript && (
                                                                                <div className="itemList__item" onClick={handleViewTranscript}>View Transcript</div>
                                                                            )}
                                                                            {showTranscript && (
                                                                                <div className="itemList__item" onClick={handleDownloadAudioTranscript}>Download Audio & Transcript</div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    : null
                                                                }
                                                            </CustomUseRef>}
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {audioPopup &&
                            <AIEncounter
                                audioPopup={audioPopup}
                                handleCloseAudio={handleCloseAudio}
                                initialData={initialData}
                                handleAddEncounter={handleSaveAIEncounter}
                                setShowAiIcon={setShowAiIcon}
                                setEncounterData={setEncounterData}
                                reRecordAI={reRecordAI}
                                setReRecordAI={setReRecordAI}
                                resumeAI={resumeAI}
                                setResumeAI={setResumeAI}
                            />
                        }
                        {viewTranscriptPopup}

                        {/* {initialData?.Data?.IsAIGenerated === 'true' && initialData?.Data?.ClinicalAINoteJobsID === "" && initialData?.Data?.IsGroupEncounter !== 'true' ?
                            <div className="ar_ai-encounter-button" onClick={() => setAudioPopup(!audioPopup)}>
                                <div className="ai-enable-encounter flex-center rounded-5">
                                    <i className='icon-ai-encounter fs-18'></i>
                                </div>
                            </div> : initialData?.Data?.IsAIGenerated === 'true' && initialData?.Data?.ClinicalAINoteJobsID === "" && initialData?.Data?.IsGroupEncounter === 'true' && isGroupNote ?
                                <div className="ar_ai-encounter-button" onClick={() => setAudioPopup(!audioPopup)}>
                                    <div className="ai-enable-encounter flex-center rounded-5">
                                        <i className='icon-ai-encounter fs-18'></i>
                                    </div>
                                </div>
                                : null} */}

                    </div>
                    {/* {isCustomNote !== "true" &&  */}
                    {isLoading ? <Loader /> : null}
                    {showImportSection ?
                        <ImportTemplate customTemplateData={props?.customTemplateData} setCustomTemplateData={props?.setCustomTemplateData} setSaveCustomTemplateData={props?.setSaveCustomTemplateData} handleSetDefaultItemsForValidation={props?.handleSetDefaultItemsForValidation} isCustomNote={props?.isCustomNote} mainCustomTemplateData={props?.mainCustomTemplateData}
                            viewImport={viewImport}
                            NoteType={searchParam?.NoteType} setShowImportSection={setShowImportSection} isLoading={isLoading} setIsLoading={setIsLoading} /> : <></>}
                    {/* } */}
                </>
            }
            <Modal show={isAIProcessing} onHide={handleCloseAIProcessing} backdrop="static" keyboard={false} centered dialogClassName="delete-modal hk-modal-v1 ar_delte_modal mw-370px w-auto">
                {/* {isLoading ? <Loader /> : null} */}
                <ModalBody>
                    <div className='d-flex justify-content-between delete-header align-items-center mb-12 p-0'>
                        <p className="heading dark-clr fs-14">Discard Recording?</p>
                        <i className='icon-x-cros fs-20 dark-clr' onClick={handleCloseAIProcessing}></i>
                    </div>
                    <div className='undo-body p-0'>
                        <div className='ar-alert d-flex m-0 gap-1'>
                            <span className="d-flex mt-3px">
                                <IconAlert />
                            </span>
                            <p className='text'>You have an unfinished AI encounter.  Choose how you'd like to continue.</p>
                        </div>
                    </div>
                </ModalBody>

                <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-between gap-2 ar_footer">
                    <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={handleCloseAIProcessing} >Cancel</button>
                    <div className="d-flex align-items-center gap-2">
                        <button className='btn btn-outline-white px-10 h-100 Denied-clr' onClick={handleReRecordAI}>Re-Record</button>
                        <button className='btn btn-danger px-10 h-100' onClick={handleResumeAI}>Resume</button>
                    </div>
                </div>
            </Modal>
        </>
    )
})

export default EncounterDetails